(ns guidebook.views.stress-test-results
  (:require
   ["moment" :as moment]
   [cljss.core :as cljss]
   [css.core :refer [defstyled]]
   [css.vars :as vars]
   [css.typography :as typo]
   [guidebook.common :refer [title-s]]
   [reagent.format :as fmt]
   [very.re-frame.core :as rf]))

(defstyled page-s :div
  {:padding "134px"
   :min-height "100vh"
   ::cljss/media {[:print]
                  {:padding "100px 100px 134px"}}})

(defstyled comparison-s :div
  {:display "grid"
   :place-items "center"
   :padding "0 50px"
   :grid-template-columns "1fr 1px 1fr"
   ::cljss/media {[:print]
                  {:padding "0"
                   :grid-template-columns "1fr 6.25rem 1fr"}}})

(defstyled subtitle-s :h2
  {:color "black"
   :font-size "1.5625rem"
   :margin "6.25rem 0 3.75rem"
   :font-weight 300
   :text-align "center"
   ::cljss/media {[:print]
                  {:font-size "1.25rem"
                   :margin "3.75rem"}}})

(defstyled vr-s :hr
  {:border "none"
   :background vars/border-light
   :width "1px"
   :height "460px"
   :margin "0"
   ::cljss/media {[:print]
                  {:height "100%"}}})

(defstyled data-cell-title-s :h3
  {:font-size "20px"
   :color "#525151"
   :font-weight "700"
   :text-align (with-meta #(or % "left") :text-align)
   :text-transform "uppercase"
   ::cljss/media {[:print]
                  {:text-align "center"}}})

(defstyled updown-graph-s :div
  {:width "540px"
   :height "420px"
   :display "grid"
   :grid-template-columns "[left-start] max-content [left-end middle-start] 1fr [middle-end right-start] max-content [right-end]"
   :grid-template-rows "min-content 1fr 1fr"
   ::cljss/media {[:print]
                  {:width "100%"
                   :height "100%"}}})

(defstyled updown-graph-arrows-s :div
  {:background-image "url(/assets/icons/arrow--updown.svg)"
   :background-position "center"
   :background-repeat "no-repeat"
   :background-size "contain"
   :grid-column "middle"
   :grid-row "span 2"})

(defstyled graph-pct-s :div
  {:font-size "34px"
   :color "#333333"
   :line-height "42px"
   :text-align "right"})

(defstyled graph-label-s :h4
  {:font-size "1.25rem"
   :color vars/gray
   :text-align "right"
   :font-weight "300"
   :margin-top ".5rem"
   :text-transform "uppercase"
   ::cljss/media {[:print]
                  {:font-size "1rem"}}})

(defstyled five-year-s :div
  {:justify-self "end"
   :align-self "center"
   :margin-bottom "3rem"
   :grid-column (with-meta identity :grid-column)})

(defstyled one-year-down-s :div
  {:justify-self "start"
   :align-self "center"
   :margin-top "3rem"
   :margin-right (with-meta #(or % "0") :margin-right)})

(defstyled one-year-up-s :div
  {:justify-self "end"
   :align-self "center"
   :margin-top "3rem"})

(defstyled graph-title-s :h3
  {:font-size "1.25rem"
   :text-transform "uppercase"
   :text-align "center"
   :grid-column "span 3"
   :margin-bottom "1rem"
   :color vars/gray
   :font-weight "700"
   ::cljss/media {[:print]
                  {:font-size "1rem"}}})

(defstyled stat-list-s :dl
  {:display "grid"
   :grid-template-columns "2fr 3fr"
   :grid-gap "2.5rem"
   :font-size "1.375rem"
   :align-items "center"
   :width "100%"
   ::cljss/media {[:print]
                  {:grid-gap "1.5rem 2rem"}}})

(defstyled stat-label-s :dt
  {::cljss/media {[:print]
                  {:font-size "1rem"}}})

(defstyled stat-value-s :dd
  {:text-align "right"
   :font-weight "700"
   :color (with-meta #(if % % "inherit") :color)
   ::cljss/media {[:print]
                  {:font-size "1.125rem"}}})

(defstyled stat-date-s :div
  {:grid-column "span 2"
   :text-align "center"
   :font-size "1.25rem"
   :font-weight "700"
   ::cljss/media {[:print]
                  {:font-size "1rem"}}})

(defstyled disclaimer-s :div
  {:font-size "1.5625rem"
   :font-weight "300"
   :line-height "2.25rem"
   :grid-template-columns "max-content"
   :justify-content "center"
   :display "grid"
   :margin "10rem 0 0"
   ::cljss/media {[:print]
                  {:font-size "1rem"
                   :margin "5rem 0 0"}}})

(defstyled disclaimer-text-s :p
  {::cljss/media {[:print]
                  {:-webkit-margin-before 0
                   :-webkit-margin-after 0}}})

(defn percent-fmt [x]
  ((fnil #(fmt/format "%d%" %) 0) x))

(defn updown-graph [data title]
  [updown-graph-s
   [graph-title-s title]
   [updown-graph-arrows-s]
   [five-year-s {:grid-column "right"}
    [graph-pct-s
     (when (> (:five-year-expected-return data) 0) "+")
     (percent-fmt (:five-year-expected-return data))]
    [graph-label-s "5 Years"]]
   [one-year-down-s {:margin-right "2rem"}
    [graph-pct-s
     (when (> (:one-year-downside data) 0) "+")
     (percent-fmt (:one-year-downside data))]
    [graph-label-s "1 Year"]]
   [one-year-up-s
    [graph-pct-s
     (when (> (:one-year-expected-return data) 0) "+")
     (percent-fmt (:one-year-expected-return data))]
    [graph-label-s "1 Year"]]])

(defn stat-value [data datum better]
  [stat-value-s {:color (when (get-in data better) "#2ea35d")}
   (get-in data datum) "%"])

(defn format-date [date]
  (-> date
      (moment)
      (.format "MMM D, Y")))

(defn date-range [data]
  [stat-date-s (str "Performance Statistics for "
                    (-> data
                        (get-in [:date-start :data])
                        (format-date))
                    " to "
                    (-> data
                        (get-in [:date-end :data])
                        (format-date)))])

(defn stress-test-cell [data]
  [stat-list-s
   [stat-value data [:downside-risk :data] [:downside-risk :better]]
   [stat-label-s "Downside Risk"]
   [stat-value data [:yield :data] [:yield :better]]
   [stat-label-s "Portfolio Stats - Yield"]
   [stat-value data [:expense-ratio :data] [:expense-ratio :better]]
   [stat-label-s "Expense Ratio"]
   [date-range data]
   [stat-value data [:total-return :data] [:total-return :better]]
   [stat-label-s "Total Return"]
   [stat-value data [:max-drawdown :data] [:max-drawdown :better]]
   [stat-label-s "Max Drawdown"]
   [stat-value data [:volatility :data] [:volatility :better]]
   [stat-label-s "Volatility"]])

(defn score [data]
  (let [current (:current data) proposed (:proposed data)
        data-keys [:downside-risk :yield :expense-ratio :total-return
                   :max-drawdown :volatility :date-start :date-end]
        scoring-table {:downside-risk <
                       :yield >
                       :expense-ratio <
                       :total-return >
                       :max-drawdown <
                       :volatility <
                       :date-start =
                       :date-end =}
        scoring (fn [data-key data other-data]
                  [data-key {:data (data-key data)
                             :better ((scoring-table data-key) (data-key data)
                                                               (data-key other-data))}])
        current-scoring #(scoring % current proposed)
        proposed-scoring #(scoring % proposed current)]
    {:current (merge current (map current-scoring data-keys))
     :proposed (merge proposed (map proposed-scoring data-keys))}))

(defn main []
  (let [data (rf/subscribe [:guidebook/recommendation])]
    (fn []
      (when @data
        (let [scored-data (score @data)
              current (:current scored-data)
              proposed (:proposed scored-data)]
          [page-s
           [title-s {:max-width "100%"} "Stress Test Results"]
           [subtitle-s "Downside Protection"]
           [comparison-s
            [updown-graph current "Current"]
            [vr-s]
            [updown-graph proposed "Target"]]
           [subtitle-s "Stress Test"]
           [comparison-s
            [stress-test-cell current]
            [vr-s]
            [stress-test-cell proposed]]
           [disclaimer-s
            [disclaimer-text-s "Portfolio Stress Test Risk is forward looking and based on the S&P 500 down 20% over a 3 month period of time."]
            [disclaimer-text-s "* The hypothetical total return may not include all deducted fees (e.g. AUM fee) and
                               charges inherent to investing."]]])))))
